import API from "../../api/api";

const PaymentService = {
  createPaypalOrder: async (data) => {
    return API.post("auth/create-paypal-order",data)
        .then((response) => response?.data)
        .catch((error) => console.log(error.message));
  },
  capturePaypalOrder: async (data) => {
    return API.post("auth/capture-paypal-order",data)
        .then((response) => response?.data)
        .catch((error) => console.log(error.message));
  },
 
};

export default PaymentService;
